import React, { useEffect } from 'react';

export default function ConfirmModal({
  isOpen,
  title = '확인',
  message,
  confirmText = '확인',
  cancelText = '취소',
  danger = false,
  onConfirm,
  onCancel,
}) {
  // Lock body scroll when open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => { document.body.style.overflow = ''; };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 'var(--z-modal-backdrop, 7000)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '1.5rem',
        animation: 'fadeIn 0.2s ease',
      }}
      onClick={onCancel}
    >
      {/* Backdrop */}
      <div style={{
        position: 'absolute',
        inset: 0,
        background: 'rgba(0, 0, 0, 0.5)',
        backdropFilter: 'blur(4px)',
        WebkitBackdropFilter: 'blur(4px)',
      }} />

      {/* Modal card */}
      <div
        style={{
          position: 'relative',
          zIndex: 'var(--z-modal, 8000)',
          background: 'white',
          borderRadius: 'var(--radius-xl, 1rem)',
          padding: '1.5rem',
          maxWidth: '360px',
          width: '100%',
          boxShadow: '0 20px 60px rgba(0,0,0,0.3)',
          animation: 'scaleIn 0.25s cubic-bezier(0.34, 1.56, 0.64, 1) forwards',
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <h3 style={{
          margin: '0 0 0.75rem',
          fontSize: '1.1rem',
          color: danger ? 'var(--color-danger, #dc3545)' : 'var(--color-text, #333)',
          fontWeight: 700,
        }}>
          {title}
        </h3>

        <p style={{
          margin: '0 0 1.5rem',
          fontSize: '0.9rem',
          color: 'var(--color-text-secondary, #666)',
          lineHeight: 1.5,
        }}>
          {message}
        </p>

        <div style={{
          display: 'flex',
          gap: '0.75rem',
        }}>
          <button
            onClick={onCancel}
            style={{
              flex: 1,
              padding: '0.7rem',
              background: 'var(--color-surface-dim, #f8f9fa)',
              color: 'var(--color-text-secondary, #666)',
              border: '1px solid var(--color-surface-border, #e9ecef)',
              borderRadius: 'var(--radius-md, 0.5rem)',
              cursor: 'pointer',
              fontSize: '0.9rem',
              fontWeight: 600,
              transition: 'background var(--transition-fast, 150ms)',
            }}
          >
            {cancelText}
          </button>
          <button
            onClick={onConfirm}
            style={{
              flex: 1,
              padding: '0.7rem',
              background: danger
                ? 'var(--color-danger, #dc3545)'
                : 'var(--color-accent, #667eea)',
              color: 'white',
              border: 'none',
              borderRadius: 'var(--radius-md, 0.5rem)',
              cursor: 'pointer',
              fontSize: '0.9rem',
              fontWeight: 600,
              transition: 'opacity var(--transition-fast, 150ms)',
            }}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
}
